<template>
    <div :class="`custom-marker ${value.selected ? 'selected' : ''} ${this.isHover ? 'hover' : ''}`">
        <div class="content-area">
            <h4 v-if="!value.selected" :class="value.delta > 0? 'nowrap more currency' : 'nowrap minus currency'">{{value.sign}} {{value.abs}} &euro;</h4>
            <h6 v-else class="currency mb-0 nowrap" style="cursor: pointer!important">{{value.name.substring(0, 20)}}...</h6>
        </div>
        <div class="square">
        </div>
    </div>
</template>

<script>
export default {
  name: 'CustomHotelMarker',
  props: {
    value: Object,
    hover: Object
  },
  data () {
    return {
      isHover: false
    }
  },
  watch: {
    hover () {
      this.isHover = this.hover.hotel.location.name === this.value.item.hotel.location.name
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/google-map/CustomHotelMarker.vue